
export default {
    props: {
        partCategories: {
            type: Array,
            default: () => {}
        }
    },
}
